import {Component, OnInit, Output, EventEmitter, Inject} from 'ng-metadata/core';

import {BlankIllService} from './blankIll.service';
import {OPAC_TAB,ChangeTabEvent} from '../search/fullView/getit/opac/opac.directive';
import {LimitedHistoryStack} from '../infra/dataStructures/collections/stack/limitedHistoryStack.structure';
import { OpacService } from '../search/fullView/getit/opac/opac.service';
import { RequestService } from '../search/fullView/getit/opac/request/request.service';
import {MediaQueries} from "../infra/mediaQueries.service";
import {ReportProblemService} from "../reportProblem/reportProblem.service";
import {ConfigurationUtil} from "../nddUtils/configurationUtil.service";
import {PagesTitlesService} from "../infra/accessibility/pagesTitles.service";
import {SearchFieldsService} from "../search/search.fields.service";

@Component({
    selector: 'prm-blank-ill',
    templateUrl: 'components/blankIll/blank-ill.html'
})

export class PrmBlankIll implements OnInit{

    @Output()   private changeTabEvent: EventEmitter<ChangeTabEvent>= new EventEmitter();

    public backToHistoryStack: LimitedHistoryStack<OPAC_TAB>;
    private defaultTab = OPAC_TAB.REQUEST;
    private _selectedTab:OPAC_TAB;
    private BACK_HISTORY_SIZE :number = 12;
    private service;

    constructor(private requestService : RequestService,
                private blankIllService: BlankIllService,
                private opacService : OpacService,
                private mediaQueries: MediaQueries,
                private reportProblemService: ReportProblemService,
                private configurationUtil: ConfigurationUtil,
                private pagesTitlesService: PagesTitlesService,
                @Inject('$state') private $state: ng.ui.IStateService,
                private searchFieldsService: SearchFieldsService,
    ) {
        this.backToHistoryStack = new LimitedHistoryStack<OPAC_TAB>(this.BACK_HISTORY_SIZE);
        this._selectedTab = this.defaultTab;
        this.updatePagesTitles();
    }

    public getRequestIsLoading(){
        return this.requestService.requestIsLoading;
    }
    public onChangeTabEvent($event){
        let eventData:ChangeTabEvent = $event;

        if($event === null){
            this.selectedTab = this.backToHistoryStack.pop() || this.defaultTab;
        } else {
            if(eventData.referer !== undefined) {
                this.backToHistoryStack.push(eventData.referer);
            }
            if (eventData.service) {
                this.service = eventData.service;
            }
            this.selectedTab = eventData.dest;
        }
    }

    get selectedTab() {
        return this._selectedTab;
    }

    set selectedTab(selectedTab) {
        this._selectedTab = selectedTab;
    }

    get responseStatus() {
        return this.opacService.responseStatus;
    }
    public isSuprima() {
        return this.configurationUtil.isSuprima();
    }

    private updatePagesTitles() {
        if(this.isSuprima()) {
            let searchQuery = this.searchFieldsService.mainSearch;
            let actionToCode = {
                'blankIll': ['nui.mainmenu.description.BlankIll', '$$QUERY$$'],
            };

            let titles = {codes: actionToCode[this.$state.current.name], query: searchQuery};
            this.pagesTitlesService.updatePagesTitles(titles);
        }
    }
    public getResponseMessage(){
        const element = document.getElementById('responseStatus');
        if(element) {
            element.setAttribute('tabindex', '0');
            element.focus();
        }
        return this.opacService.getResponseMessage();

    }

    get displayErrorMessage() {
        return this.requestService.displayErrorMessage;
    }

    public isReportProblem() {
        return this.reportProblemService.isReportProblem();
    }
}


// WEBPACK FOOTER //
// ./src/main/webapp/components/blankIll/blankIll.directive.ts